import React from 'react';
import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_p1_subjects from './uganda_p1_subjects';
import TopNavbar from '../../components/TopNavbar';
import Uganda_classes from './uganda_classes';
import International_countries from '../international_countries';

const Uganda_p1 = ( ) => {
 
  return (
    <>
 <TopNavbar />
    <Uganda />
  <International_countries />
  <Uganda_p1_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_p1;
